import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const getAppSettings = (country) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/GetAppSettings",
          params: {'country': country},
          headers:  { "Content-Type": "application/json"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}

export const updateAiIndicator = (aiInd, country) => {
    return new Promise((resolve, reject) => {
        const jwtToken = window.localStorage.getItem('jwtToken');

        axios({
            method: "POST",
            url: api_url + "/UpdateAiIndicator",
            data: {
                aiInd: aiInd,
                country: country
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + jwtToken
            }
        })
        .then(
            (response) => resolve(response.data),
            (error) => {
                console.error(error);
                reject(error);
            }
        );
    });
};
